import { CommentWithReplies } from "../../../../../../types/comments";
import { XStack, YStack, Text, View } from "tamagui";
import { getRelativeTime } from "../utils";

type CommentReplyProps = {
  reply: CommentWithReplies;
};

export const CommentReply = ({ reply }: CommentReplyProps) => {
  return (
    <XStack mt="$3">
      <View w={4} bg="$brandYellow" borderRadius={2} />
      <YStack
        flex={1}
        bg="rgba(0, 0, 0, 0.03)"
        p="$3"
        borderTopRightRadius="$3"
        borderBottomRightRadius="$3"
      >
        <XStack justifyContent="space-between" alignItems="center" mb="$1">
          <Text
            fontFamily="$heading"
            fontSize={14}
            fontWeight="bold"
            textTransform="uppercase"
          >
            {reply.profile?.name}
          </Text>
          <Text fontSize={12} color="$gray10">
            {getRelativeTime(reply.created_at)}
          </Text>
        </XStack>
        <Text fontSize={14}>{reply.content}</Text>
      </YStack>
    </XStack>
  );
};
